{
  "de": {
    "search": {
      "placeholders": {
        "query": "Suche nach Fragen oder Stichworten"
      },
      "title": "Suche"
    }
  }
}
